import { FontSize } from '../common-types'

export const getFontClasses = (fontSize?: FontSize) => {
  switch (fontSize) {
    case 'size-78':
      return '!text-[40px] !leading-[48px] xl:!text-[72px] xl:!leading-[80px]'
    case 'size-54':
      return '!text-[34px] !leading-[40px] xl:!text-[54px] xl:!leading-[64px]'
    case 'size-48':
      return '!text-2xl lg:!text-[48px] lg:!leading-[60px]'
    case 'size-40':
      return '!text-2xl lg:!text-[40px] lg:!leading-[48px]'
    case 'size-34':
      return '!text-xl lg:!text-[34px] lg:!leading-[40px]'
    case 'size-24':
      return '!text-lg !leading-7 lg:!text-2xl lg:!leading-9'
    case 'size-28':
      return 'lg:text-2xl text-xl font-medium lg:leading-8 leading-6 tracking-[0.2px]'
    case 'size-20':
      return 'text-xl'
    case 'size-18':
      return '!text-lg !leading-7'
    case 'size-16':
      return '!text-base !leading-6'
    case 'size-13':
      return '!text-[13px] !leading-5'
    default:
      return ''
  }
}
